import Cookies from 'js-cookie'
import { BehaviorSubject } from 'rxjs'
import { postJsonData, fetchJsonData } from '../../../global/data/service.js'
import {
  ESC_PROFILE_KEY,
  CONTACT_KEY,
} from '../../../global/authentication/authentication-manager.js'
import { isLocal } from '../../../global/environments/index.js'
import mockProfileJson from '../../../../test/components/EmailSubscriptionCenter/Landing/data/mock-esc-profile.json'
import mockAdvisorProfileJsonNew from '../../../../test/components/EmailSubscriptionCenter/Landing/data/mock-esc-profile-advisor-new.json'
import mockUserSubscriptionsNew from '../../../../test/components/EmailSubscriptionCenter/Landing/data/mock-user-subscriptions-new.json'
import mockBlacklistedEmailJson from '../../../../test/components/EmailSubscriptionCenter/Landing/data/mock-blacklisted-email.json'
import {
  THOUGHT_LEADERSHIP,
  AUTHOR,
  TOPIC,
} from '../Landing/Helper/constants.js'
import {
  getFundSubscription,
  getSubscriptions,
} from '../../../spa/components/productDetail/Helper.js'

function getStorageProfile() {
  const profile = localStorage.getItem(ESC_PROFILE_KEY) || null
  return JSON.parse(profile)
}

function setStorageProfile(profile) {
  localStorage.setItem(ESC_PROFILE_KEY, profile)
}

export function getContactKey() {
  const contactKey = Cookies.get(CONTACT_KEY) || null
  return JSON.parse(contactKey)
}

export function setContactKey(key) {
  Cookies.set(CONTACT_KEY, key, { secure: true })
}

async function updateProfile(data) {
  const url = '/api/updateProfile'

  return postJsonData(url, data)
}

async function updateProfileAdvisor(data) {
  const url = '/api/secure/updateProfile'

  return postJsonData(url, data)
}

async function updateSubscriptions(data) {
  const url = '/api/updateSubscriptions'
  if (isLocal()) {
    return { mockSucess: true }
  } else {
    return postJsonData(url, data)
  }
}

async function postCheckSubscription(data) {
  if (!data) {
    data = getStorageProfile()
  }

  const url = '/api/checkSubscriptions'

  if (isLocal()) {
    // return data && data.role === 'Advisor' ? mockAdvisorProfileJson : mockProfileJson
    return data && data.role === 'Advisor'
      ? mockAdvisorProfileJsonNew
      : mockProfileJson
  } else {
    if (!data) {
      return { value: undefined }
    }

    return postJsonData(url, data)
  }
}

export async function getSubscriptionsForUser(key) {
  if (!key) {
    key = getContactKey()
    if (!key) {
      return postCheckSubscription()
    }
  }

  const url = `/api/getSubscriptions?contactId=${key}&type=All`

  let data
  if (isLocal()) {
    // data = mockUserSubscriptions
    data = mockUserSubscriptionsNew
  } else {
    data = await fetchJsonData(url)
  }

  if (data) {
    // if it throws a 404, it means there is not data set in salesforce yet
    // and we return an empty array of data
    if (data.error) {
      const profile = getStorageProfile()

      return {
        value: {
          contactID: `${key}`,
          firstName: profile.firstName,
          lastName: profile.lastName,
          emailId: profile.emailId,
          role: profile.role,
          source: 'ESC',
          thoughtLeadershipSubscriptions: [],
          authorSubscriptions: [],
          productLiteratureSubscriptions: [],
          printSubcriptions: [],
          subscriptions: [],
        },
      }
    }
    if (data.value) {
      const storageProfile = getStorageProfile()
      data.value.role = storageProfile.role
    }
  }

  return data
}

async function postSubscriptionsRegistration(data) {
  const url = '/api/subscriptionsRegistration'

  if (isLocal()) {
    return mockBlacklistedEmailJson
  } else {
    if (!data) {
      return { value: undefined }
    }

    return postJsonData(url, data)
  }
}

async function getSubscriptionProfile() {
  return postCheckSubscription(getStorageProfile())
}

async function getFirms() {
  // return mockFirms
  return postJsonData('/advexp.svc/firms', {})
}

async function getSubscriptionFunds() {
  const data = await getFundSubscription()

  return data
}

async function getSubscriptionFundByCusip(cusip) {
  const funds = await getSubscriptionFunds()
  const filteredArray = funds.funds.filter((fund) =>
    fund.cusip.some((cusipItem) => cusipItem === cusip)
  )
  return filteredArray.length > 0 ? filteredArray[0] : null
}

async function getSubscriptionDataById(id) {
  const subscriptions = await getSubscriptions()
  return subscriptions.subscriptions.find((sub) => sub.id === id)
}

async function getSubscriptionsByName(name) {
  return getSubscriptionsByNameList([name])
}

async function getSubscriptionsByNameList(names) {
  const subscriptions = await getSubscriptions()

  let foundSubscriptions = []
  names.map((name) => {
    const lowercasedName = name.replace(/\W/g, '').toLowerCase()
    subscriptions.subscriptions.map((subscription) => {
      if (
        subscription.name.replace(/\W/g, '').toLowerCase() === lowercasedName
      ) {
        foundSubscriptions.push(subscription)
      }
    })
  })

  const sorted = [THOUGHT_LEADERSHIP, AUTHOR, TOPIC]
  foundSubscriptions = foundSubscriptions.sort((a, b) => {
    const aScore = sorted.indexOf(a.category)
    const bScore = sorted.indexOf(b.category)
    return aScore > bScore ? 1 : -1
  })

  return foundSubscriptions
}

const modelLiteratureDocs = new BehaviorSubject([])

export {
  getSubscriptions,
  getSubscriptionFunds,
  updateSubscriptions,
  postCheckSubscription,
  postSubscriptionsRegistration,
  getSubscriptionProfile,
  getFirms,
  updateProfile,
  updateProfileAdvisor,
  getStorageProfile,
  setStorageProfile,
  getSubscriptionFundByCusip,
  getSubscriptionDataById,
  getSubscriptionsByName,
  getSubscriptionsByNameList,
  modelLiteratureDocs,
}
